import React from 'react';

import { ContentSet } from 'components/Shared/Scaffolding';
import Panel, { PanelTitle } from 'components/Shared/Panel';
import LocationForm from 'components/LocationSettings/LocationForm';
import { SCAFFOLDING } from 'theme';
import { clearPreviewLocation } from 'modules/navigation/preview';
import { formName } from 'modules/location';
import withCancel from 'components/Shared/PanelCancel';

const LocationPanel = ({ open, onClose, onCancel }) => (
    <Panel open={open} onClose={onCancel}>
        <ContentSet spacing={SCAFFOLDING.GUTTER} padding={SCAFFOLDING.GUTTER}>
            <PanelTitle>Size & Location</PanelTitle>
            <p>
                Set a custom size for the map that fits well on your website. Pan and zoom the map on the right to your
                desired location. Alternatively, enter the latitude, longitude, and zoom level below.
            </p>
            <LocationForm onClose={onClose} onCancel={onCancel} />
        </ContentSet>
    </Panel>
);

export default withCancel({
    form: formName,
    dispatches: [clearPreviewLocation()],
})(LocationPanel);
